<template>
  <div v-bind:class="{ 'rtg-modal':true, show:show }" @click="close">
    <div class="rtg-modal-container">
      <div class="rtg-modal-content" @click.stop>
        <div class="confirmation">
          <div v-if="error === '' && !success">
            <label>Confirm "Ready to go" status for Reservation #{{rsvpID}}</label>
            <div class="button cta error" @click="close">Cancel</div>
            <div class="button cta success" @click="confirm">Confirm</div>
          </div>

          <div v-else-if="!success" class="error">
            <i class="fas fa-exclamation-triangle fa-3x"></i>
            <label>{{ error }}</label>
            <div class="button cta error small block" @click="close">Close</div>
          </div>

          <div v-if="success" class="success">
            <i class="far fa-check-circle fa-3x"></i>
            <label>Successfully applied "Ready to go" status on Reservation #{{rsvpID}}</label>
            <div class="button cta success small block" @click="close">Close</div>
          </div>

          <transition name="fade">
            <div class="loader" v-show="loading">
              <i class="fas fa-spinner fa-spin fa-4x"></i>
              Please wait...
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ready-to-go-modal',
  data () {
    return {
      error: '',
      success: false
    }
  },
  computed: {
    show () { return this.$store.state.dispatch.readyToGo.show },
    loading () { return this.$store.state.dispatch.readyToGo.loading },
    rsvpID () { return this.$store.state.dispatch.readyToGo.id },
    rtgSuccess () { return this.$store.state.dispatch.readyToGo.success }
  },
  methods: {
    close () {
      if (this.loading) { return }
      this.error = ''
      this.success = false
      this.$store.commit('dispatch/setReadyToGoID', 0)
      this.$store.commit('dispatch/setReadyToGoShow', false)

      if (this.rtgSuccess && this.$route.name === 'RsvpDetails') {
        this.$store.commit('dispatch/setReadyToGoSuccess', false)
        location.reload()
      }
    },
    confirm () {
      let self = this
      if (self.loading) { return }
      self.$store.commit('dispatch/setReadyToGoLoading', true)

      self.$sdk.post('/admin/rsvp/' + this.rsvpID + '/ready', {
        token: self.$store.state.session.sessionToken
      }, res => {
        self.$store.commit('dispatch/setReadyToGoLoading', false)
        if (res.error) {
          self.error = res.error.message
          return
        }

        self.success = true
        self.$store.commit('dispatch/setReadyToGoSuccess', true)
      })
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.rtg-modal {
  position: fixed;
  z-index: 999;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
  display: table;
  opacity: 0;
  transition: all 250ms;

  &.show{
    top: 0;
    opacity: 1;
  }
}

.rtg-modal-container {
  display: table-cell;
  vertical-align: middle;
}

.rtg-modal-content {
  background-color: #fff;
  border-radius: 3px;
  max-width: 500px;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.35);
  text-align: center;
  overflow: hidden;
}

.confirmation{
  padding:30px;
  position: relative;

  label{
    display:block;
    margin-bottom: 30px;
    font-size:15px;
    font-weight: 600;
    color:#444;
  }
  .button{ margin: 0 5px; }
  .error i{
    display: block;
    margin-bottom: 10px;
    color: #ecaa32;
  }
  .success i{
    display: block;
    margin-bottom: 10px;
    color: #26d97a;
  }
  .loader{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
    font-weight: 600;
    color: #333;
    background: rgba(255,255,255, .8);

    i{
      margin-top: 30px;
      color:#2669bd;
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dispatch/ReadyToGoModal.vue